import { baseApi } from "./baseApi";

export interface SchedulerTaskStatus {
  name: string;
  enabled: boolean;
  running: boolean;
  cron: string;
}

export interface SchedulerStatusResponse {
  success: boolean;
  schedulerRunning: boolean;
  schedulerGloballyEnabled: boolean;
  tasks: SchedulerTaskStatus[];
}

export interface NotificationLogEntry {
  _id: string;
  timestamp: string;
  channel: string;
  recipient: string;
  message: string;
  status: string;
  statusDetail?: string;
  source?: string;
  metadata?: Record<string, unknown>;
}

export interface NotificationLogsResponse {
  success: boolean;
  logs: NotificationLogEntry[];
}

export type NotificationLogsQueryArgs = {
  limit?: number;
  before?: string;
  channel?: string;
  task?: string;
};

export const schedulerAdminApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSchedulerStatus: builder.query<SchedulerStatusResponse, void>({
      query: () => "/admin/scheduler",
      providesTags: ["Scheduler"],
    }),
    toggleSchedulerTask: builder.mutation<
      SchedulerStatusResponse,
      { taskName: string; enabled: boolean }
    >({
      query: ({ taskName, enabled }) => ({
        url: `/admin/scheduler/${encodeURIComponent(taskName)}`,
        method: "PATCH",
        body: { enabled },
      }),
      invalidatesTags: ["Scheduler"],
    }),
    getNotificationLogs: builder.query<
      NotificationLogsResponse,
      NotificationLogsQueryArgs | void
    >({
      query: (arg) => ({
        url: "/admin/scheduler/logs",
        params:
          arg === undefined
            ? {}
            : {
                ...(arg.limit != null ? { limit: arg.limit } : {}),
                ...(arg.before ? { before: arg.before } : {}),
                ...(arg.channel ? { channel: arg.channel } : {}),
                ...(arg.task ? { task: arg.task } : {}),
              },
      }),
      providesTags: ["SchedulerLogs"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetSchedulerStatusQuery,
  useToggleSchedulerTaskMutation,
  useGetNotificationLogsQuery,
  useLazyGetNotificationLogsQuery,
} = schedulerAdminApi;
